@if (currentPageDetails) {
  <div class="main-paginator-container">
    <span
      class="paginator-item-count"
      [ngClass]="{
        hidden: !showPageSizeSelector,
      }"
    >
      <app-ui-select
        class="page-size-select"
        [label]="'pageSize' | translate"
        [control]="pageSizeControl"
        [options]="pageSizeSelectOptions"
        [isMultiple]="false"
        [enableSearch]="false"
        (changeHandler)="pageSizeChangeEvent($event)"
      ></app-ui-select>
    </span>
    <div
      class="paginator-right-details"
      [ngClass]="{
        'page-navigator': !showPageSizeSelector,
      }"
    >
      <span class="page-index-display">
        {{ 'page' | translate }} {{ currentPageDetails.pageIndex + 1 }} {{ 'of' | translate }}
        {{ totalPages }}
      </span>
      <app-ui-button
        buttonType="icon-button"
        icon="navigate_before"
        [disabled]="!hasPreviousPage"
        (click)="previousPage()"
      ></app-ui-button>
      <app-ui-button
        buttonType="icon-button"
        icon="navigate_next"
        [disabled]="!hasNextPage"
        (click)="nextPage()"
      ></app-ui-button>
    </div>
  </div>
}
